import { render, staticRenderFns } from "./CriteriaViewEditInPlace.vue?vue&type=template&id=0b7ce634&scoped=true"
import script from "./CriteriaViewEditInPlace.vue?vue&type=script&setup=true&lang=js"
export * from "./CriteriaViewEditInPlace.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriteriaViewEditInPlace.vue?vue&type=style&index=0&id=0b7ce634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ce634",
  null
  
)

export default component.exports